import { render, staticRenderFns } from "./ExpedienteProductoresActionsCellRenderer.vue?vue&type=template&id=24bb3fa0"
import script from "./ExpedienteProductoresActionsCellRenderer.vue?vue&type=script&lang=js"
export * from "./ExpedienteProductoresActionsCellRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports